import { render, staticRenderFns } from "./ProductGroupQueryList.vue?vue&type=template&id=9598308c&scoped=true&"
import script from "./ProductGroupQueryList.vue?vue&type=script&lang=js&"
export * from "./ProductGroupQueryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9598308c",
  null
  
)

export default component.exports